module.exports = __webpack_public_path__ + "images/icon/radio_on_select-d3d56d93.svg";